"use client";
import React, { useEffect } from "react";
import { usePathname } from "next/navigation";
import ErrorFallback from "@/components/common/ErrorFallback";
import { reportClientError } from "@/lib/errorReporter";
import StackTrace from "stacktrace-js";

export default function GlobalErrorBoundary({ error, reset }) {
  const pathname = usePathname();
  useEffect(() => {
    const href =
      typeof window !== "undefined" ? window.location.href : pathname;
    (async () => {
      let frames = [];
      try {
        if (error) {
          const stackFrames = await StackTrace.fromError(error);
          frames = stackFrames.map((f) => ({
            fileName: f.fileName,
            functionName: f.functionName,
            lineNumber: f.lineNumber,
            columnNumber: f.columnNumber,
          }));
        }
      } catch {}
      reportClientError(error, {
        subject: "Global Rendering Error",
        layout: "global-boundary",
        route: href,
        resolved_frames: frames,
      });
    })();
  }, [error,pathname]);

  return (
    <html>
      <body>
        <ErrorFallback
          title="Unexpected application error"
          description={error?.message || "An unexpected error occurred."}
          onRetry={() => reset()}
        />
      </body>
    </html>
  );
}
